export const formatUSD = (value) => {
  if (value == null || isNaN(value)) return "—";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(value);
};

export const formatMiles = (miles) => {
  if (miles == null) return "—";
  return `${new Intl.NumberFormat("en-US").format(miles)} mi`;
};

export const titleCase = (str) => {
  if (!str) return "";
  return str.replace(/\b\w/g, (c) => c.toUpperCase()).replace(/_/g, " ");
};

export const roleHome = (role) => {
  switch (role) {
    case "dealer":
      return "/dealer";
    case "bdc":
      return "/bdc";
    case "admin":
      return "/admin";
    case "customer":
    default:
      return "/account";
  }
};

export const LEAD_STATUS_META = {
  new: { label: "New", tone: "bg-slate-100 text-slate-700 border-slate-200" },
  contacted: { label: "Contacted", tone: "bg-blue-50 text-blue-700 border-blue-200" },
  followed_up: { label: "Followed up", tone: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  lost: { label: "Lost", tone: "bg-slate-100 text-slate-500 border-slate-200" },
  spam: { label: "Spam", tone: "bg-rose-50 text-rose-700 border-rose-200" },
};
